<div class="page">

  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>{{ compound?.name_en || compound?.name_ar || 'Compound' }}</h1>
        <p dir="rtl" *ngIf="compound?.name_ar">{{ compound?.name_ar }}</p>
      </div>
    </div>
    <div class="header-actions" *ngIf="compound && !isEditMode">
      <button class="btn-secondary" (click)="enableEdit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Edit
      </button>
      <button class="btn-danger" (click)="confirmDelete()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
        </svg>
        Delete
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-lg"></div>
    <p>Loading compound...</p>
  </div>

  <ng-container *ngIf="!isLoading && compound">

    <div class="toast-success" *ngIf="successMessage">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      {{ successMessage }}
    </div>

    <!-- ── VIEW MODE ── -->
    <div *ngIf="!isEditMode">

      <div class="detail-card">

        <!-- Info -->
        <div class="detail-section">
          <div class="promo-head">
            <h2 class="section-title">Launches &amp; offers</h2>
            <button class="btn-secondary" type="button" (click)="addPromotion()">Add launch or offer</button>
          </div>
          <p class="promo-note">Adding one ends whatever is running on this compound. Followers are notified.</p>
          <div class="promo-row" *ngFor="let p of promotions">
            <span class="promo-type" [class.offer]="p.type === 'offer'">{{ p.type === 'offer' ? 'Offer' : 'Launch' }}</span>
            <span class="promo-title">{{ p.title_en || p.title_ar }}</span>
            <span class="promo-when">{{ p.starts_at | date:'mediumDate' }} → {{ p.ends_at ? (p.ends_at | date:'mediumDate') : 'open' }}</span>
            <span class="promo-status" [ngClass]="promotionStatus(p)">{{ promotionStatus(p) }}</span>
            <button class="link-btn" type="button" *ngIf="promotionStatus(p) === 'live'" (click)="endPromotion(p)">End now</button>
          </div>
          <p class="promo-empty" *ngIf="!promotions.length">Nothing yet.</p>
        </div>

        <div class="detail-divider"></div>

        <div class="detail-section">
          <app-phases-manager [compoundId]="compound.id"></app-phases-manager>
        </div>

        <div class="detail-divider"></div>

        <div class="detail-section">
          <h2 class="section-title">Compound Info</h2>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Name (English)</span>
              <span class="info-value">{{ compound.name_en || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Name (Arabic)</span>
              <span class="info-value" dir="rtl">{{ compound.name_ar }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Developer</span>
              <span class="info-value info-link" *ngIf="compound.developer" (click)="goToDeveloper()">
                {{ compound.developer.name_en || compound.developer.name_ar }}
              </span>
              <span class="info-value" *ngIf="!compound.developer">—</span>
            </div>
            <div class="info-item">
              <span class="info-label">Status</span>
              <span class="badge" [class.badge-active]="compound.is_active" [class.badge-inactive]="!compound.is_active">
                {{ compound.is_active ? 'Active' : 'Inactive' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Area</span>
              <span class="info-value">{{ compound.area?.name_en || compound.area?.name_ar || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Delivery</span>
              <span class="info-value">{{ compound.delivery_date ? (compound.delivery_date | date:'mediumDate') : '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Finishing</span>
              <span class="info-value">{{ finishingLabel(compound.finishing) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Payment</span>
              <span class="info-value">{{ paymentLabels(compound.payment_options) }}{{ compound.down_payment_percent ? ' · ' + (+compound.down_payment_percent) + '% down' : '' }}{{ compound.installment_years ? ' · ' + compound.installment_years + ' yrs' : '' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Amenities</span>
              <span class="info-value">{{ amenityLabels(compound.amenities) }}</span>
            </div>
            <div class="info-item" *ngIf="compound.units_count !== undefined">
              <span class="info-label">Listings</span>
              <span class="info-value">{{ compound.units_count }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Created At</span>
              <span class="info-value">{{ compound.created_at | date:'medium' }}</span>
            </div>
          </div>
        </div>

        <div class="detail-divider"></div>

        <!-- Description -->
        <div class="detail-section" *ngIf="compound.desc_en || compound.desc_ar">
          <h2 class="section-title">Description</h2>
          <div class="desc-pair">
            <div *ngIf="compound.desc_en">
              <span class="info-label">English</span>
              <p class="desc-text">{{ compound.desc_en }}</p>
            </div>
            <div *ngIf="compound.desc_ar">
              <span class="info-label">Arabic</span>
              <p class="desc-text" dir="rtl">{{ compound.desc_ar }}</p>
            </div>
          </div>
        </div>

        <div class="detail-divider" *ngIf="compound.desc_en || compound.desc_ar"></div>

        <!-- Reference & location -->
        <div class="detail-section">
          <h2 class="section-title">Reference &amp; location</h2>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Reference #</span>
              <span class="info-value">{{ compound.nawy_id ? '#' + compound.nawy_id : 'Added by hand' }}</span>
            </div>
            <div class="info-item" *ngIf="compound.additional_info?.source?.url">
              <span class="info-label">Source</span>
              <a class="info-value info-link" [href]="compound.additional_info!.source!.url" target="_blank" rel="noopener">
                Open source page{{ compound.additional_info!.source!.scraped_at ? ' (scraped ' + compound.additional_info!.source!.scraped_at + ')' : '' }}
              </a>
            </div>
            <div class="info-item">
              <span class="info-label">Area</span>
              <span class="info-value">
                {{ compound.area?.name_en || '—' }}{{ compound.additional_info?.location?.parent_area_en ? ' · ' + compound.additional_info!.location!.parent_area_en : '' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Coordinates</span>
              <span class="info-value" *ngIf="compound.latitude && compound.longitude">{{ +compound.latitude | number:'1.4-6' }}, {{ +compound.longitude | number:'1.4-6' }}</span>
              <span class="info-value" *ngIf="!compound.latitude || !compound.longitude">—</span>
            </div>
            <div class="info-item">
              <span class="info-label">Area outline</span>
              <span class="info-value">{{ boundaryPoints() ? boundaryPoints() + ' points' : '—' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Brochure</span>
              <a class="info-value info-link" *ngIf="compound.brochure_url" [href]="compound.brochure_url" target="_blank" rel="noopener">Open brochure</a>
              <span class="info-value" *ngIf="!compound.brochure_url">—</span>
            </div>
          </div>

          <div class="ref-block" *ngIf="compound.aliases?.length">
            <span class="info-label">Also known as</span>
            <div class="chip-row">
              <span class="alias-chip" *ngFor="let a of compound.aliases" [attr.dir]="isArabic(a) ? 'rtl' : 'ltr'">{{ a }}</span>
            </div>
          </div>

          <div class="ref-block" *ngIf="compound.master_plan">
            <span class="info-label">Master plan</span>
            <div class="main-image-view"><img [src]="compound.master_plan" alt="master plan" /></div>
          </div>

          <div class="ref-block" data-test="plan-overlay">
            <span class="info-label">Plan on the map</span>
            <p class="promo-note">Drawn over the satellite map in the app. Pick the three files of the georeferenced plan together: <b>.tif</b>, <b>.tfw</b> and <b>.prj</b>. The plan is placed from them automatically.</p>
            <div class="main-image-view" *ngIf="compound.plan_overlay_url"><img [src]="compound.plan_overlay_url" alt="plan on the map" /></div>
            <p class="promo-note" *ngIf="compound.plan_bounds">Placed at {{ compound.plan_bounds[1] | number:'1.4-4' }}, {{ compound.plan_bounds[0] | number:'1.4-4' }} → {{ compound.plan_bounds[3] | number:'1.4-4' }}, {{ compound.plan_bounds[2] | number:'1.4-4' }}</p>
            <div class="chip-row">
              <span class="alias-chip">.tif: {{ planFiles.tif?.name || '—' }}</span>
              <span class="alias-chip">.tfw: {{ planFiles.tfw?.name || '—' }}</span>
              <span class="alias-chip">.prj: {{ planFiles.prj?.name || '—' }}</span>
            </div>
            <div class="chip-row">
              <label class="btn-add">Choose files<input type="file" multiple accept=".tif,.tiff,.tfw,.prj" hidden (change)="pickPlanFiles($event)" /></label>
              <button type="button" class="btn-add" [disabled]="!planReady || planBusy" (click)="uploadPlan()">{{ planBusy ? 'Uploading…' : (compound.plan_overlay_url ? 'Replace plan' : 'Upload plan') }}</button>
              <button type="button" class="btn-add" *ngIf="compound.plan_overlay_url" [disabled]="planBusy" (click)="removePlan()">Remove plan</button>
            </div>
            <p class="promo-note" *ngIf="planError" style="color:#c0392b">{{ planError }}</p>
          </div>
        </div>

        <div class="detail-divider"></div>

        <!-- Market snapshot -->
        <div class="detail-section" *ngIf="compound.additional_info?.market || compound.additional_info?.property_types?.length">
          <h2 class="section-title">Market snapshot</h2>
          <p class="promo-note" *ngIf="compound.additional_info?.market">
            From the source on {{ compound.additional_info!.market!.as_of || '—' }}. Reference only — not a live price. Live prices come from the listings.
          </p>
          <div class="info-grid" *ngIf="compound.additional_info?.market">
            <div class="info-item" *ngIf="compound.additional_info!.market!.resale_starting_price">
              <span class="info-label">Resale from</span>
              <span class="info-value">{{ compound.additional_info!.market!.resale_starting_price | number }} {{ compound.additional_info!.market!.currency }}</span>
            </div>
            <div class="info-item" *ngIf="compound.additional_info!.market!.developer_starting_price">
              <span class="info-label">Developer from</span>
              <span class="info-value">{{ compound.additional_info!.market!.developer_starting_price | number }} {{ compound.additional_info!.market!.currency }}</span>
            </div>
          </div>
          <div class="ref-block" *ngIf="compound.additional_info?.property_types?.length">
            <span class="info-label">Unit types on the source</span>
            <div class="chip-row">
              <span class="alias-chip" *ngFor="let t of compound.additional_info!.property_types">{{ t.type }} · {{ t.count }}</span>
            </div>
          </div>
        </div>

        <div class="detail-divider" *ngIf="compound.additional_info?.market || compound.additional_info?.property_types?.length"></div>

        <!-- FAQs -->
        <div class="detail-section">
          <h2 class="section-title">FAQs ({{ compound.faqs?.length || 0 }})</h2>
          <p class="promo-empty" *ngIf="!compound.faqs?.length">No questions yet. Add some in Edit — the assistant answers from them.</p>
          <div class="faq-card" *ngFor="let f of compound.faqs">
            <div class="faq-pair">
              <div>
                <p class="faq-q">{{ f.question_en }}</p>
                <p class="faq-a">{{ f.answer_en }}</p>
              </div>
              <div dir="rtl">
                <p class="faq-q">{{ f.question_ar || '—' }}</p>
                <p class="faq-a">{{ f.answer_ar || '—' }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-divider"></div>

        <!-- Main Image -->
        <div class="detail-section" *ngIf="compound.main_image">
          <h2 class="section-title">Main Image</h2>
          <div class="main-image-view">
            <img [src]="compound.main_image" [alt]="compound.name_en" />
          </div>
        </div>

        <div class="detail-divider" *ngIf="compound.main_image"></div>

        <!-- Gallery -->
        <div class="detail-section">
          <h2 class="section-title">Gallery ({{ compound.gallery?.length || 0 }} images)</h2>
          <div class="gallery-grid" *ngIf="compound.gallery && compound.gallery.length > 0">
            <div class="gallery-thumb" *ngFor="let url of compound.gallery; let i = index">
              <img [src]="url" [alt]="'gallery-' + i" class="gallery-img" />
            </div>
          </div>
          <p class="no-content" *ngIf="!compound.gallery || compound.gallery.length === 0">No gallery images.</p>
        </div>

        <div class="detail-divider"></div>

        <!-- Features -->
        <div class="detail-section">
          <h2 class="section-title">Features ({{ compound.features?.length || 0 }})</h2>

          <div class="features-view" *ngIf="compound.features && compound.features.length > 0">
            <div class="feature-view-card" *ngFor="let f of compound.features; let i = index">

              <div class="fvc-header">
                <div class="fvc-titles">
                  <span class="fvc-title-en">{{ f.title_en || '—' }}</span>
                  <span class="fvc-title-ar" dir="rtl">{{ f.title_ar || '—' }}</span>
                </div>
              </div>

              <div class="fvc-subtitles" *ngIf="f.subtitle_en || f.subtitle_ar">
                <span *ngIf="f.subtitle_en">{{ f.subtitle_en }}</span>
                <span *ngIf="f.subtitle_ar" dir="rtl" class="fvc-sub-ar">{{ f.subtitle_ar }}</span>
              </div>

              <div class="fvc-images" *ngIf="f.images && f.images.length > 0">
                <div class="fvc-thumb" *ngFor="let img of f.images; let j = index">
                  <img [src]="img" [alt]="'feat-' + i + '-img-' + j" class="fvc-img" />
                </div>
              </div>

            </div>
          </div>
          <p class="no-content" *ngIf="!compound.features || compound.features.length === 0">No features defined.</p>
        </div>

        <div class="detail-divider"></div>

        <!-- Properties -->
        <div class="detail-section">
          <h2 class="section-title">
            Properties
            <span class="props-count-badge" *ngIf="propsTotal > 0">{{ propsTotal }}</span>
          </h2>

          <!-- Loading -->
          <div class="props-loading" *ngIf="propsLoading">
            <div class="spinner-sm"></div>
            <span>Loading properties…</span>
          </div>

          <ng-container *ngIf="!propsLoading">

            <div class="props-grid" *ngIf="properties.length > 0">
              <div class="prop-card" *ngFor="let item of properties" (click)="goToProperty(item.id)">

                <!-- Cover -->
                <div class="prop-cover">
                  <img *ngIf="item.images && item.images.length > 0"
                    [src]="item.images[0]" [alt]="item.title" class="cover-img" />
                  <div *ngIf="!item.images || item.images.length === 0" class="cover-placeholder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                      <polyline points="9 22 9 12 15 12 15 22"/>
                    </svg>
                  </div>
                  <div class="prop-badges-cover">
                    <span class="type-badge">{{ item.property_type }}</span>
                    <span class="status-badge" [ngClass]="propStatusClass(item.property_status)">
                      {{ item.property_status }}
                    </span>
                  </div>
                  <span class="featured-badge" *ngIf="item.is_featured">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                    Featured
                  </span>
                </div>

                <!-- Body -->
                <div class="prop-body">
                  <h3 class="prop-title" dir="rtl">{{ item.title }}</h3>
                  <p class="prop-price">{{ formatPrice(item.price) }}</p>
                  <div class="prop-specs">
                    <span class="spec" *ngIf="item.size">{{ item.size }} م²</span>
                    <span class="spec" *ngIf="item.bedrooms">{{ item.bedrooms }} غرف</span>
                    <span class="spec" *ngIf="item.bathrooms">{{ item.bathrooms }} حمام</span>
                    <span class="spec" *ngIf="item.state">{{ item.state }}</span>
                  </div>
                  <div class="prop-footer">
                    <span class="active-dot" [class.active]="item.is_active" [class.inactive]="!item.is_active"></span>
                    <span class="active-label">{{ item.is_active ? 'Active' : 'Inactive' }}</span>
                    <span class="prop-date">{{ item.created_at | date:'mediumDate' }}</span>
                  </div>
                </div>

              </div>
            </div>

            <p class="no-content" *ngIf="properties.length === 0">No properties linked to this compound.</p>

            <!-- Pagination -->
            <div class="pagination-bar" *ngIf="propsTotal > 0">
              <div class="pagination-info">
                Showing <strong>{{ propsRangeStart }}–{{ propsRangeEnd }}</strong> of <strong>{{ propsTotal }}</strong>
              </div>
              <div class="pagination-controls">
                <button class="page-btn page-btn-nav" (click)="propsGoToPage(propsPage - 1)" [disabled]="propsPage === 1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"/>
                  </svg>
                </button>
                <ng-container *ngFor="let p of propsPageNumbers">
                  <span class="page-gap" *ngIf="p === -1">…</span>
                  <button *ngIf="p !== -1" class="page-btn"
                    [class.page-btn-active]="p === propsPage"
                    (click)="propsGoToPage(p)">{{ p }}</button>
                </ng-container>
                <button class="page-btn page-btn-nav" (click)="propsGoToPage(propsPage + 1)" [disabled]="propsPage === propsTotalPages">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </button>
              </div>
              <div class="pagination-size">
                <label>Per page</label>
                <select [(ngModel)]="propsLimit" (change)="propsOnPageSizeChange()">
                  <option *ngFor="let s of propsPageSizes" [ngValue]="s">{{ s }}</option>
                </select>
              </div>
            </div>

          </ng-container>
        </div>

      </div>
    </div>

    <!-- ── EDIT MODE ── -->
    <div *ngIf="isEditMode">
      <div class="error-msg" *ngIf="errorMessage">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        {{ errorMessage }}
      </div>

      <form class="form-card" (ngSubmit)="saveEdit()">

        <!-- Basic Info -->
        <div class="form-section">
          <h2 class="section-title">Compound Info</h2>

          <div class="form-row">
            <div class="form-group">
              <label>Developer <span class="required">*</span></label>
              <select [(ngModel)]="editForm.developer_id" name="developer_id">
                <option [ngValue]="0" disabled>Select a developer</option>
                <option *ngFor="let d of developers" [ngValue]="d.id">{{ d.name_en || d.name_ar }}</option>
              </select>
            </div>
          </div>

          <!-- Name bilingual card -->
          <div class="bilingual-block">
            <div class="bilingual-inputs">
              <div class="form-group">
                <label>Arabic Name <span class="required">*</span></label>
                <input type="text" [(ngModel)]="editForm.name_ar" name="name_ar" dir="rtl" />
              </div>
              <div class="form-group">
                <label>English Name</label>
                <input type="text" [(ngModel)]="editForm.name_en" name="name_en" />
              </div>
            </div>
            <div class="translate-strip">
              <button type="button" class="btn-translate"
                (click)="translateNameToAr()"
                [disabled]="translating.nameToAr || !editForm.name_en?.trim()">
                <span *ngIf="!translating.nameToAr">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"/>
                  </svg>
                  Translate EN → AR
                </span>
                <span *ngIf="translating.nameToAr" class="spinner-xs"></span>
              </button>
              <span class="translate-divider">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
                </svg>
                Name Auto-translate
              </span>
              <button type="button" class="btn-translate"
                (click)="translateNameToEn()"
                [disabled]="translating.nameToEn || !editForm.name_ar?.trim()">
                <span *ngIf="!translating.nameToEn">
                  Translate AR → EN
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </span>
                <span *ngIf="translating.nameToEn" class="spinner-xs"></span>
              </button>
            </div>
            <div class="translate-error" *ngIf="translateErrors.nameToEn || translateErrors.nameToAr">
              Translation failed — please try again.
            </div>
          </div>

          <!-- Description bilingual card -->
          <div class="bilingual-block">
            <div class="bilingual-inputs">
              <div class="form-group">
                <label>Description (Arabic)</label>
                <textarea [(ngModel)]="editForm.desc_ar" name="desc_ar" rows="3" dir="rtl"></textarea>
              </div>
              <div class="form-group">
                <label>Description (English)</label>
                <textarea [(ngModel)]="editForm.desc_en" name="desc_en" rows="3"></textarea>
              </div>
            </div>
            <div class="translate-strip">
              <button type="button" class="btn-translate"
                (click)="translateDescToAr()"
                [disabled]="translating.descToAr || !editForm.desc_en?.trim()">
                <span *ngIf="!translating.descToAr">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"/>
                  </svg>
                  Translate EN → AR
                </span>
                <span *ngIf="translating.descToAr" class="spinner-xs"></span>
              </button>
              <span class="translate-divider">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
                </svg>
                Description Auto-translate
              </span>
              <button type="button" class="btn-translate"
                (click)="translateDescToEn()"
                [disabled]="translating.descToEn || !editForm.desc_ar?.trim()">
                <span *ngIf="!translating.descToEn">
                  Translate AR → EN
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </span>
                <span *ngIf="translating.descToEn" class="spinner-xs"></span>
              </button>
            </div>
            <div class="translate-error" *ngIf="translateErrors.descToEn || translateErrors.descToAr">
              Translation failed — please try again.
            </div>
          </div>

          <div class="form-group check-group">
            <label class="checkbox-label">
              <input type="checkbox" [(ngModel)]="editForm.is_active" name="is_active" />
              <span>Active</span>
            </label>
          </div>
        </div>

        <div class="form-divider"></div>

        <!-- Main Image -->
        <div class="form-section">
          <h2 class="section-title">Location &amp; unit defaults</h2>
          <div class="form-group">
            <label>Area</label>
            <select [(ngModel)]="editForm.area_id" name="area_id">
              <option [ngValue]="null">— not set —</option>
              <option *ngFor="let a of areas" [ngValue]="a.id">{{ a.name_en || a.name_ar }}</option>
            </select>
          </div>
          <app-listing-attributes-fields [form]="$any(editForm)" tagsKey="amenities"></app-listing-attributes-fields>
        </div>

        <div class="form-divider"></div>

        <div class="form-section">
          <app-compound-profile-fields [form]="editForm"></app-compound-profile-fields>
        </div>

        <div class="form-divider"></div>

        <div class="form-section">
          <app-compound-reference-fields [form]="editForm"></app-compound-reference-fields>
        </div>

        <div class="form-divider"></div>

        <div class="form-section">
          <h2 class="section-title">Main Image</h2>
          <div class="form-group">
            <input type="text" [(ngModel)]="editForm.main_image" name="main_image"
              placeholder="https://example.com/compound-cover.jpg" />
          </div>
          <div class="main-image-view" *ngIf="editForm.main_image">
            <img [src]="editForm.main_image" alt="main image preview" />
          </div>
        </div>

        <div class="form-divider"></div>

        <!-- Gallery -->
        <div class="form-section">
          <h2 class="section-title">Gallery</h2>
          <div class="url-input-row">
            <input type="text" [(ngModel)]="galleryInput" name="galleryInput"
              placeholder="https://example.com/photo.jpg"
              (keydown)="onGalleryKeydown($event)" class="url-input" />
            <button type="button" class="btn-add" (click)="addGalleryImage()">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              Add
            </button>
          </div>
          <div class="thumb-grid" *ngIf="editForm.gallery.length > 0">
            <div class="thumb-item" *ngFor="let url of editForm.gallery; let i = index">
              <img [src]="url" [alt]="'gallery-' + i" class="thumb-img" />
              <button type="button" class="btn-remove-thumb" (click)="removeGalleryImage(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>
          <p class="empty-hint" *ngIf="editForm.gallery.length === 0">No images yet.</p>
        </div>

        <div class="form-divider"></div>

        <!-- Features -->
        <div class="form-section">
          <div class="section-header">
            <h2 class="section-title">Features</h2>
            <button type="button" class="btn-add-feature" (click)="openFeatureForm()" *ngIf="!showFeatureForm">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              Add Feature
            </button>
          </div>

          <div class="features-list" *ngIf="editForm.features.length > 0">
            <ng-container *ngFor="let f of editForm.features; let i = index">

              <!-- Collapsed feature card -->
              <div class="feature-card" *ngIf="editingFeatureIndex !== i">
                <div class="feature-card-header">
                  <div>
                    <span class="feature-title-en">{{ f.title_en || '—' }}</span>
                    <span class="feature-title-ar" dir="rtl">{{ f.title_ar || '—' }}</span>
                  </div>
                  <div class="feature-card-meta">
                    <span class="feature-img-count" *ngIf="f.images.length > 0">{{ f.images.length }} img</span>
                    <button type="button" class="btn-edit-feature" (click)="startEditFeature(i)"
                      [disabled]="showFeatureForm || (editingFeatureIndex !== null && editingFeatureIndex !== i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                      </svg>
                    </button>
                    <button type="button" class="btn-remove-feature" (click)="removeFeature(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </button>
                  </div>
                </div>
                <p class="feature-subtitle">{{ f.subtitle_en }}</p>
              </div>

              <!-- Inline feature editor -->
              <div class="feature-builder" *ngIf="editingFeatureIndex === i">
                <h3 class="builder-title">Edit Feature</h3>

                <!-- Title bilingual card -->
                <div class="bilingual-block">
                  <div class="bilingual-inputs">
                    <div class="form-group">
                      <label>Title (Arabic) <span class="required">*</span></label>
                      <input type="text" [(ngModel)]="newFeature.title_ar" [name]="'ef_title_ar_' + i" dir="rtl" />
                    </div>
                    <div class="form-group">
                      <label>Title (English)</label>
                      <input type="text" [(ngModel)]="newFeature.title_en" [name]="'ef_title_en_' + i" />
                    </div>
                  </div>
                  <div class="translate-strip">
                    <button type="button" class="btn-translate"
                      (click)="translateFeatTitleToAr()"
                      [disabled]="translating.featTitleToAr || !newFeature.title_en?.trim()">
                      <span *ngIf="!translating.featTitleToAr">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="15 18 9 12 15 6"/>
                        </svg>
                        Translate EN → AR
                      </span>
                      <span *ngIf="translating.featTitleToAr" class="spinner-xs"></span>
                    </button>
                    <span class="translate-divider">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
                      </svg>
                      Title Auto-translate
                    </span>
                    <button type="button" class="btn-translate"
                      (click)="translateFeatTitleToEn()"
                      [disabled]="translating.featTitleToEn || !newFeature.title_ar?.trim()">
                      <span *ngIf="!translating.featTitleToEn">
                        Translate AR → EN
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="9 18 15 12 9 6"/>
                        </svg>
                      </span>
                      <span *ngIf="translating.featTitleToEn" class="spinner-xs"></span>
                    </button>
                  </div>
                  <div class="translate-error" *ngIf="translateErrors.featTitleToEn || translateErrors.featTitleToAr">
                    Translation failed — please try again.
                  </div>
                </div>

                <!-- Subtitle bilingual card -->
                <div class="bilingual-block">
                  <div class="bilingual-inputs">
                    <div class="form-group">
                      <label>Subtitle (Arabic)</label>
                      <input type="text" [(ngModel)]="newFeature.subtitle_ar" [name]="'ef_sub_ar_' + i" dir="rtl" />
                    </div>
                    <div class="form-group">
                      <label>Subtitle (English)</label>
                      <input type="text" [(ngModel)]="newFeature.subtitle_en" [name]="'ef_sub_en_' + i" />
                    </div>
                  </div>
                  <div class="translate-strip">
                    <button type="button" class="btn-translate"
                      (click)="translateFeatSubtitleToAr()"
                      [disabled]="translating.featSubtitleToAr || !newFeature.subtitle_en?.trim()">
                      <span *ngIf="!translating.featSubtitleToAr">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="15 18 9 12 15 6"/>
                        </svg>
                        Translate EN → AR
                      </span>
                      <span *ngIf="translating.featSubtitleToAr" class="spinner-xs"></span>
                    </button>
                    <span class="translate-divider">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
                      </svg>
                      Subtitle Auto-translate
                    </span>
                    <button type="button" class="btn-translate"
                      (click)="translateFeatSubtitleToEn()"
                      [disabled]="translating.featSubtitleToEn || !newFeature.subtitle_ar?.trim()">
                      <span *ngIf="!translating.featSubtitleToEn">
                        Translate AR → EN
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="9 18 15 12 9 6"/>
                        </svg>
                      </span>
                      <span *ngIf="translating.featSubtitleToEn" class="spinner-xs"></span>
                    </button>
                  </div>
                  <div class="translate-error" *ngIf="translateErrors.featSubtitleToEn || translateErrors.featSubtitleToAr">
                    Translation failed — please try again.
                  </div>
                </div>

                <!-- Images -->
                <div class="form-group">
                  <label>Feature Images</label>
                  <div class="url-input-row">
                    <input type="text" [(ngModel)]="featureImageInput" [name]="'ef_img_' + i"
                      placeholder="https://example.com/feature.jpg"
                      (keydown)="onFeatureImageKeydown($event)" class="url-input" />
                    <button type="button" class="btn-add" (click)="addFeatureImage()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                      </svg>
                      Add
                    </button>
                  </div>
                  <div class="thumb-grid" *ngIf="newFeature.images.length > 0">
                    <div class="thumb-item" *ngFor="let url of newFeature.images; let j = index">
                      <img [src]="url" [alt]="'ef-img-' + j" class="thumb-img" />
                      <button type="button" class="btn-remove-thumb" (click)="removeFeatureImage(j)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="builder-actions">
                  <button type="button" class="btn-secondary" (click)="cancelEditFeature()">Cancel</button>
                  <button type="button" class="btn-primary" (click)="saveEditFeature()">Save Feature</button>
                </div>
              </div>

            </ng-container>
          </div>
          <p class="empty-hint" *ngIf="editForm.features.length === 0 && !showFeatureForm">No features yet.</p>

          <!-- Add new feature builder -->
          <div class="feature-builder" *ngIf="showFeatureForm">
            <h3 class="builder-title">New Feature</h3>

            <!-- Title bilingual card -->
            <div class="bilingual-block">
              <div class="bilingual-inputs">
                <div class="form-group">
                  <label>Title (Arabic) <span class="required">*</span></label>
                  <input type="text" [(ngModel)]="newFeature.title_ar" name="new_feat_title_ar" dir="rtl" />
                </div>
                <div class="form-group">
                  <label>Title (English)</label>
                  <input type="text" [(ngModel)]="newFeature.title_en" name="new_feat_title_en" />
                </div>
              </div>
              <div class="translate-strip">
                <button type="button" class="btn-translate"
                  (click)="translateFeatTitleToAr()"
                  [disabled]="translating.featTitleToAr || !newFeature.title_en?.trim()">
                  <span *ngIf="!translating.featTitleToAr">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="15 18 9 12 15 6"/>
                    </svg>
                    Translate EN → AR
                  </span>
                  <span *ngIf="translating.featTitleToAr" class="spinner-xs"></span>
                </button>
                <span class="translate-divider">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
                  </svg>
                  Title Auto-translate
                </span>
                <button type="button" class="btn-translate"
                  (click)="translateFeatTitleToEn()"
                  [disabled]="translating.featTitleToEn || !newFeature.title_ar?.trim()">
                  <span *ngIf="!translating.featTitleToEn">
                    Translate AR → EN
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="9 18 15 12 9 6"/>
                    </svg>
                  </span>
                  <span *ngIf="translating.featTitleToEn" class="spinner-xs"></span>
                </button>
              </div>
              <div class="translate-error" *ngIf="translateErrors.featTitleToEn || translateErrors.featTitleToAr">
                Translation failed — please try again.
              </div>
            </div>

            <!-- Subtitle bilingual card -->
            <div class="bilingual-block">
              <div class="bilingual-inputs">
                <div class="form-group">
                  <label>Subtitle (Arabic)</label>
                  <input type="text" [(ngModel)]="newFeature.subtitle_ar" name="new_feat_subtitle_ar" dir="rtl" />
                </div>
                <div class="form-group">
                  <label>Subtitle (English)</label>
                  <input type="text" [(ngModel)]="newFeature.subtitle_en" name="new_feat_subtitle_en" />
                </div>
              </div>
              <div class="translate-strip">
                <button type="button" class="btn-translate"
                  (click)="translateFeatSubtitleToAr()"
                  [disabled]="translating.featSubtitleToAr || !newFeature.subtitle_en?.trim()">
                  <span *ngIf="!translating.featSubtitleToAr">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="15 18 9 12 15 6"/>
                    </svg>
                    Translate EN → AR
                  </span>
                  <span *ngIf="translating.featSubtitleToAr" class="spinner-xs"></span>
                </button>
                <span class="translate-divider">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
                  </svg>
                  Subtitle Auto-translate
                </span>
                <button type="button" class="btn-translate"
                  (click)="translateFeatSubtitleToEn()"
                  [disabled]="translating.featSubtitleToEn || !newFeature.subtitle_ar?.trim()">
                  <span *ngIf="!translating.featSubtitleToEn">
                    Translate AR → EN
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="9 18 15 12 9 6"/>
                    </svg>
                  </span>
                  <span *ngIf="translating.featSubtitleToEn" class="spinner-xs"></span>
                </button>
              </div>
              <div class="translate-error" *ngIf="translateErrors.featSubtitleToEn || translateErrors.featSubtitleToAr">
                Translation failed — please try again.
              </div>
            </div>

            <!-- Images -->
            <div class="form-group">
              <label>Feature Images</label>
              <div class="url-input-row">
                <input type="text" [(ngModel)]="featureImageInput" name="new_feat_img"
                  placeholder="https://example.com/feature.jpg"
                  (keydown)="onFeatureImageKeydown($event)" class="url-input" />
                <button type="button" class="btn-add" (click)="addFeatureImage()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                  </svg>
                  Add
                </button>
              </div>
              <div class="thumb-grid" *ngIf="newFeature.images.length > 0">
                <div class="thumb-item" *ngFor="let url of newFeature.images; let j = index">
                  <img [src]="url" [alt]="'new-feat-img-' + j" class="thumb-img" />
                  <button type="button" class="btn-remove-thumb" (click)="removeFeatureImage(j)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="builder-actions">
              <button type="button" class="btn-secondary" (click)="cancelFeature()">Cancel</button>
              <button type="button" class="btn-primary" (click)="addFeature()">Add Feature</button>
            </div>
          </div>
        </div>

        <div class="form-divider"></div>

        <div class="form-actions">
          <button type="button" class="btn-secondary" (click)="cancelEdit()">Cancel</button>
          <button type="submit" class="btn-primary" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Save Changes</span>
            <span *ngIf="isSubmitting" class="spinner-sm"></span>
          </button>
        </div>

      </form>
    </div>

  </ng-container>

  <!-- Delete Modal -->
  <div class="modal-overlay" *ngIf="showDeleteModal">
    <div class="modal-confirm">
      <div class="modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
        </svg>
      </div>
      <h3>Delete Compound</h3>
      <p>Are you sure you want to delete <strong>{{ compound?.name_en || compound?.name_ar }}</strong>? This action cannot be undone.</p>
      <div class="modal-btns">
        <button class="btn-secondary" (click)="cancelDelete()">Cancel</button>
        <button class="btn-danger-solid" (click)="deleteCompound()" [disabled]="isDeleting">
          <span *ngIf="!isDeleting">Yes, Delete</span>
          <span *ngIf="isDeleting" class="spinner-sm"></span>
        </button>
      </div>
    </div>
  </div>

</div>
